import React, { Component, useEffect, useState } from "react";
import { postData, getData, patchData, deleteData } from "../../util/Fetch";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { format, subDays } from "date-fns";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import zhTW from "date-fns/locale/zh-TW";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

const Bill = () => {
  const [selectedFromDate, setSelectedFromDate] = useState(
    new Date(new Date().setDate(1))
  );
  const [selectedToDate, setSelectedToDate] = useState(new Date());

  const [bills, setBills] = useState({
    billData: [],
    totalIncome: [],
  });
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    getData("Report", {}).then((res) => {
      setBills(res);
    });
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const tableCellStyle = {
    borderBottom: "", // 默认边框为下边框
  };

  const lastCellBorderStyle = {
    borderBottom: "none", // 最后一个单元格的下边框
  };

  const handleFromDateChange = (date) => {
    setSelectedFromDate(date);
  };

  const handleToDateChange = (date) => {
    setSelectedToDate(date);
  };

  const handleSearch = () => {
    postData("Report", {
      fromDate: selectedFromDate,
      toDate: selectedToDate,
    }).then((res) => {
      setBills(JSON.parse(res));
    });
  };

  return (
    <div>
      <div>
        <LocalizationProvider adapterLocale={zhTW} dateAdapter={AdapterDateFns}>
          <DatePicker
            label="開始日期"
            value={selectedFromDate}
            onChange={handleFromDateChange}
            inputFormat={"yyyy/MM/dd"}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <LocalizationProvider adapterLocale={zhTW} dateAdapter={AdapterDateFns}>
          <DatePicker
            label="結束日期"
            value={selectedToDate}
            onChange={handleToDateChange}
            inputFormat={"yyyy/MM/dd"}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <Button
          variant="contained"
          onClick={handleSearch}
          sx={{ height: "56px" }}
        >
          查詢
        </Button>
      </div>
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>日期</TableCell>
              <TableCell align="right">項目</TableCell>
              <TableCell align="right">單價</TableCell>
              <TableCell align="right">數量</TableCell>
              <TableCell align="right">折數</TableCell>
              <TableCell align="right">折價</TableCell>
              <TableCell align="right">實收</TableCell>
              <TableCell align="right">實業績/店販抽成</TableCell>
              <TableCell align="right">備註</TableCell>
              <TableCell align="right">指定</TableCell>
              <TableCell align="right">開發</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(rowsPerPage > 0
              ? Object.keys(bills.billData).slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                )
              : bills.billDatas
            ).map((billId) =>
              bills.billData[billId].map((row, index, array) => (
                <TableRow
                  key={`${billId}-${index}`} // Unique key for each row
                  sx={{
                    borderBottom: index === 0 ? 0 : 1, // Remove bottom border for last row
                    borderTop: index === array.length - 1 ? 0 : 1, // Remove top border for first row
                  }}
                >
                  {index === 0 && (
                    <TableCell rowSpan={bills.billData[billId].length}>
                      {format(new Date(row.date), "yyyy-MM-dd")}
                    </TableCell>
                  )}
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.item}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.price}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.count}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.isHelp === false && <>{row.percentageDiscount}%</>}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.isHelp === false && <>{row.fixAmountDiscount}</>}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.realPrice}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.resultPrice}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.note}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.isHelp === false && (
                      <>{row.assign ? <CheckCircleIcon /> : ""}</>
                    )}
                  </TableCell>
                  <TableCell
                    align="right"
                    sx={
                      index === array.length - 1
                        ? tableCellStyle
                        : lastCellBorderStyle
                    }
                  >
                    {row.isHelp === false && (
                      <>{row.develop ? <CheckCircleIcon /> : ""}</>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={Object.keys(bills.billData).length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        labelRowsPerPage="每頁行數："
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableBody>
            {Object.entries(bills.totalIncome).map(([key, value]) => (
              <TableRow
                key={"name"}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{key}</TableCell>
                <TableCell>{value}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Bill;
